export const UNCATEGORIZED = 'Uncategorized';
